import { useMemo } from 'react';
import { useDebounce } from '../useDebounce';
import { DEBOUNCE_DELAY } from '../../utils/emendas/constants';

export const useGlobalSearch = (data, searchTerm) => {
  const debouncedSearch = useDebounce(searchTerm, DEBOUNCE_DELAY);

  const filteredData = useMemo(() => {
    if (!debouncedSearch.trim()) return data;
    
    const searchLower = debouncedSearch.toLowerCase();
    return data.filter(row => 
      Object.values(row).some(value => 
        String(value).toLowerCase().includes(searchLower)
      )
    );
  }, [data, debouncedSearch]);

  return filteredData;
};
